export default {
  'cost.label.reportType': 'Select report type',
  'cost.label.budgetType': 'Budget Type',
  'cost.label.status': 'Status',
  'cost.label.filterByDate': 'Filter by date',

  'cost.option.costXSale': 'Cost x Sale (Parts)',
  'cost.option.fixedCost': 'Fixed Cost',
  'cost.option.variableCost': 'Variable Cost',
  'cost.option.generalCost': 'General Cost',
  'cost.option.budget': 'Budget',
  'cost.option.warranty': 'Warranty',
  'cost.option.return': 'Return',
  'cost.option.courtesy': 'Courtesy',
  'cost.option.insideCourtesy': 'Inside (Courtesy)',
  'cost.option.totalLoss': 'Total Loss',
  'cost.option.revision': 'Revision',
  'cost.option.open': 'Open',
  'cost.option.liquidated': 'Liquidated',
  'cost.option.emission': 'Emission',
  'cost.option.dueDate': 'Due Date',
  'cost.option.payment': 'Payment',
};
